import clsx from "clsx"
import { DropDown, Spinner } from "../../utils/UtilComponents"
import { Drafts, ThresholdCategoryData } from "./types"

type UnitFormProps = {
    userThresholds: ThresholdCategoryData[]
    drafts: Drafts,
    updateUnit : (catKey: string, newUnit: string) => void,
    onSave: () => Promise<void>,
    loadState: boolean,
    updateState:boolean,
}

export const UnitsForm = ({
    userThresholds,
    drafts,
    updateUnit,
    onSave,
    loadState,
    updateState
} : UnitFormProps) => {
    return(
        <>
            <div className="grid grid-cols md:grid-cols-3 p-2 gap-4 w-full overflow-y-auto border rounded-lg border-[#94a3b8]">
              {
                userThresholds.map(category => {
                    return( 
                        Object.keys(category.unitOptions).length > 0 &&
                        <div className="flex flex-col p-2 bg-[#F8F8F8] border border-[#94a3b8] rounded-xl p-3 shadow-sm gap-2">
                            <div className="flex justify-between">
                                <p className="text-base text-[#1e293b] uppercase font-semibold">
                                    {category.label}
                                </p>
                                <p className="text-sm text-zinc-600 uppercase font-semibold bg-[#cbd5e1] p-1 rounded-lg border border-[#94a3b8]">
                                    {drafts[category.key]?.unit}
                                </p>
                            </div>
                            <DropDown
                                optionsList={category.unitOptions}
                                label="Unit selection"
                                tooltip="Select the unit for required param."
                                val={drafts[category.key]?.unit}
                                onChange={(v) =>{updateUnit(category.key, v)}}
                                edit={true}
                            />
                        </div>
                    )
                })
              }
            </div>
            <div className="flex items-center justify-center">
                <button
                    onClick={() => onSave()}
                    className={clsx(`w-1/2 font-semibold p-2
                    text-base uppercase rounded border border-inset border-[#346F3E]
                    transition duration-150`,
                    updateState ? "bg-[#FCF9C1] text-[#895B1A] hover:bg-yellow-200" : "bg-[#DFFCE6] text-green-900 hover:bg-green-200")}
                    disabled={loadState}
                >
                    {loadState ? <Spinner/> : <span>Save Units</span>}
                </button>
            </div>
        </>
    )
}